import { extendTheme } from '@chakra-ui/react'
const thinBoxShadow = '3px 3px 0 #333333'
const thinBoxShadow2 = '3px 3px 0 #454545'
const thickBoxShadow = '5px 5px 0 #333333'
const thickBoxShadow2 = '8px 8px 0 #333333'
const headingStyle = { fontFamily: 'Rubik', lineHeight: '120% !important' }
const noneImportant = 'none !important'
const neg2Important = '-2px !important'
const translateXY3 = 'translate(3px, 3px)'
const translateXY5 = 'translate(5px, 5px)'
const defaultBorder = '3px solid #333333'
const defaultBorder2 = '3px solid #575757'
const defaultBorder3 = '1px solid #e3e3e3'
const defaultBorder4 = '3px solid #bababa'
const defaultBorder5 = '1px solid #333333'
const insetBoxShadow = 'inset 0 0 0 2px #333333'
const scale975 = 'scale(0.975)'
const spaceBetween = 'space-between'
const flexStart = 'flex-start'
const arrowShadow = '8px 8px 0 #333333'
const arrowShadowImp = '8px 0px 0 0 #333333 !important'
const borderVariant5 = '3px solid #808080'
const borderVariant6 = '3px solid #6E5A8A'
const borderVariant7 = '3px solid #CB3434'
const borderVariant8 = '3px solid #787878'
const borderVariant9 = '1px solid #333'
const borderVariant10 = '1px solid #EDEDED'
const borderVariant11 = '3px solid #F0B847'
const borderVariant12 = '3px solid #454545'
const borderVariant13 = '2px solid #333333'
const borderVariant14 = '1px solid #454545'
const borderVariant15 = '1px solid #575757'
const borderVariant16 = '3px solid #e3e3e3'
const borderVariant17 = '1px solid #e2dee8'
const borderVariant18 = '2px solid #cccccc'
const borderVariant19 = '4px solid #cb3434'
const borderVariant20 = '1px solid #FCF1DA'
const borderVariant21 = '3px solid #333333'
const borderVariant22 = '1px solid #3689B0'
const borderVariant23 = '1px solid #F0B847'
const borderVariant24 = '1px solid #DEDEDE'
const borderVariant25 = '1px solid #8B7BA1'
const zeroImportant = '0 !important'
const borderBox = 'border-box'
const borderVariantOnePixel = '1px solid rgba(69, 69, 69, 0.2);'
const assessmentDivider = '3px solid #45454533'
const dashedBorder = '1px dashed #CCC'
const dashedBorderDarkGray = '1px dashed #454545'
const dashedBorderRum = '1px dashed #7C6A96'
const dashedBorderAmethyst = '1px dashed #A89CB9'
const borderVariant26 = '6.79px solid #EF3837'
const borderVariant27 = '3.375px solid transparent'
const borderVariant28 = '1px dashed #EF3837'
const borderVariant29 = '1px solid #7C6A96'
const borderVariant30 = '8px solid #F0B847'
const borderVariant31 = '3px solid #F0B847'
const borderVariant32 = '1px solid #787878'
const borderVariant33 = '3px solid #7C6A96'
const borderVariant34 = '3px solid #8B7BA1'
const borderVariant35 = '1px dashed #C5BDD0'
const borderVariant36 = '1px solid #CB3434'
const borderVariant37 = '1px dashed #949494'
const borderVariant38 = '1px solid #DB7171'
const borderVariant39 = '1px solid #F2F2F2'
const borderVariant40 = '1px solid #f3c66c'
const borderVariant41 = '1px solid #84C787'
const borderVariant42 = '1px solid #F0B847; border-bottom: none;'

const hiddenScrollbar = {
    '::-webkit-scrollbar': {
        display: 'none',
    },
    '-ms-overflow-style': 'none',
    'scrollbar-width': 'none',
}

const theme = extendTheme({
    colors: {
        alabaster: '#fafafa',
        alabaster2: '#f7f7f7',
        alto: '#d4d4d4',
        alto2: '#dedede',
        alto3: '#d9d9d9',
        alto4: '#DEDEDE66',
        amethyst: '#A89CB9',
        athensgray: '#f1eff3',
        athensgray2: '#f8f7f9',
        athensgray3: '#6b6b6b',
        athensgray4: '#FCFCFD',
        azureradiance: '#0077ee',
        blacksqueeze: '#ebf3f7',
        bostonblue: '#3689b0',
        blackcurrant: '#372D45',
        brand: {
            100: '#ef3837',
            500: '#ef3837',
        },
        boulder: '#787878',
        cinderella: '#fcd7d7',
        cinderella2: '#fdeadc',
        codgray: '#191919',
        concrete: '#f2f2f2',
        creamcan: '#f3c66c',
        dodgerblue: '#4ca0fe',
        dovegray: '#696969',
        dovegray2: '#6A6A6A',
        dovegray3: '#6F6F6F',
        ecruwhite: '#f5f7ed',
        emperor: '#545454',
        flushmahogany: '#cb3434',
        fruitsalad: '#4faf54',
        gallery: '#ededed',
        gold: '#FFD700',
        graynurse: '#eaf0ea',
        gray: '#808080',
        hintofyellow: '#FEFEF6',
        kimberly: '#8b7ba1',
        mercury: '#e3e3e3',
        mercury2: '#e5e5e5',
        mercury3: '#e4e4e4',
        mineshaft: '#333333',
        mineshaft2: '#3f3f3f',
        mischka: '#d3cddc',
        mischka2: '#e2dee8',
        oldlace: '#fdf8ed',
        dustygray: '#949494',
        oldlace2: '#fefbf6',
        oldlace3: '#fef4e5',
        olivegreen: '#9fb34e',
        pampas: '#f5f6f0',
        panache: '#edf7ee',
        pearllusta: '#fcf1da',
        pearllusta2: '#fce9cc',
        pomegranate: '#ef3837',
        provincialpink: '#fdebeb',
        progress: {
            500: '#0077fe',
        },
        ronchi: '#f0b847',
        rum: '#7c6a96',
        rum2: '#6E5A8A',
        scorpion: '#575757',
        scorpion2: '#5c5c5c',
        seashell: '#f1f1f1',
        silver: '#bababa',
        silver2: '#cccccc',
        silverchalice: '#ababab',
        smoky: '#63517c',
        martinique: '#423653',
        graySuit: '#C5BDD0',
        solitude: '#e5f1ff',
        steelblue: '#407bbf',
        steelblue2: '#3689B0',
        sycamore: '#7f8f3e',
        tablebg: {
            100: '#ffffff',
            10: '#ffffff1a',
        },
        tangerine: '#f29100',
        thistlegreen: '#c4cba6',
        tundora: '#454545',
        wepeep: '#f5d6d6',
        wepeep2: '#FAEBEB',
        wildsand: '#f5f5f5',
        wildsand2: '#f6f6f6',
        wisppink: '#fef5f5',
        zanah: '#dcefdd',
        ziggurat: '#afd0df',
        ziggurat2: '#c3dce7',
        shark: '#202327',
        shark2: '#2E3138',
        jumbo: '#828388',
        vanillaIce: '#F7E1E1',
        deYork: '#72BF76',
        sidecar: '#F5E6CA',
    },
    fonts: {
        body: 'Roboto',
        heading: 'Rubik',
    },
    fontSizes: {
        '3xs': '0.5rem', // 8px
        '2xs': '0.625rem', // 10px
        xs: '0.75rem', // 12px
        sm: '0.875rem', // 14px
        md: '1rem', // 16px
        lg: '1.125rem', // 18px         | H6
        xl: '1.3125rem', // 21px        | H5
        '2xl': '1.5rem', // 24px        | H4
        '3xl': '1.75rem', // 28px       | H3
        '3.5xl': '1.875rem', // 30px    | Not for desktop / Mobile H2
        '4xl': '2rem', // 32px          | H2 / Mobile H1
        '5xl': '2.25rem', // 36px       | H1
    },
    lineHeights: {
        lg: '1.225rem', // 19.6px
        xl: '1.313rem', // 21px
        '2xl': '1.5rem', // 24px
    },
    breakpoints: {
        sm: '360px',
        mob: '480px',
        md: '768px',
        tablet: '992px',
        lg: '1200px',
        xl: '1366px',
        '2xl': '1920px',
        '3xl': '2560px',
    },
    components: {
        Accordion: {
            variants: {
                retro: {
                    container: { border: defaultBorder, bg: 'oldlace2' },
                    button: { padding: 6 },
                    panel: { px: 6, pt: 0, pb: 6 },
                },
            },
        },
        Button: {
            baseStyle: {
                fontFamily: 'Rubik',
                fontWeight: 'bold',
            },
            variants: {
                sidebar: {
                    bg: 'white',
                    borderRadius: 0,
                    minWidth: 'auto',
                    padding: 0,
                    borderWidth: 3,
                    borderColor: 'mineshaft',
                    height: 45,
                    width: 45,
                    boxShadow: thinBoxShadow,
                    transitionDuration: '0s',
                    color: 'mineshaft',
                    _hover: {
                        color: 'pomegranate',
                    },
                    _active: {
                        boxShadow: 'none',
                        transform: translateXY3,
                    },
                },
                'sidebar-active': {
                    bg: 'white',
                    borderRadius: 0,
                    minWidth: 'auto',
                    padding: 0,
                    borderWidth: 3,
                    borderColor: 'mineshaft',
                    height: 45,
                    width: 45,
                    transitionDuration: '0s',
                    transform: translateXY3,
                    color: 'pomegranate',
                },
                'sidebar-mobile': {
                    bg: 'white',
                    borderRadius: 0,
                    minWidth: 'auto',
                    padding: 0,
                    borderWidth: 3,
                    borderColor: 'mineshaft',
                    height: '48px',
                    width: 225,
                    boxShadow: thickBoxShadow,
                    display: 'flex',
                    justifyContent: 'start',
                    transitionDuration: '0s',
                    _hover: {
                        color: 'pomegranate',
                    },
                    _active: {
                        boxShadow: 'none',
                        transform: translateXY5,
                    },
                },
                'sidebar-mobile-active': {
                    bg: 'white',
                    borderRadius: 0,
                    minWidth: 'auto',
                    padding: 0,
                    borderWidth: 3,
                    borderColor: 'mineshaft',
                    height: '48px',
                    width: 225,
                    display: 'flex',
                    justifyContent: 'start',
                    color: 'pomegranate',
                    transitionDuration: '0s',
                    transform: translateXY5,
                },
                flat: {
                    bg: 'white',
                    borderColor: 'mineshaft',
                    borderWidth: 3,
                    borderRadius: 0,
                    px: 6,
                    py: '9px',
                    height: '48px',
                },
                clickable: props => ({
                    bg: 'rum',
                    borderColor: 'mineshaft',
                    borderWidth: 3,
                    borderRadius: 0,
                    color: 'white',
                    px: 6,
                    py: '9px',
                    mr: '5px',
                    height: '48px',
                    minWidth: 'unset',
                    boxShadow: thickBoxShadow,
                    transitionDuration: '0s',
                    _active: {
                        boxShadow: 'none',
                        transform:
                            !props.isDisabled && !props.isLoading
                                ? translateXY5
                                : 'none',
                    },
                    _disabled: {
                        cursor: 'not-allowed',
                        borderColor: 'silver2',
                        color: 'silver',
                        bg: 'mercury',
                        opacity: 1,
                        _hover: {
                            bg: 'mercury !important',
                        },
                    },
                }),
                'clickable-active': {
                    bg: 'rum',
                    borderColor: 'mineshaft',
                    borderWidth: 3,
                    borderRadius: 0,
                    color: 'white',
                    px: 6,
                    py: '9px',
                    mr: '5px',
                    height: '48px',
                    minWidth: 'unset',
                    transitionDuration: '0s',
                    transform: translateXY5,
                },
                'clickable-secondary': {
                    bg: 'white',
                    borderColor: 'mineshaft',
                    borderWidth: 3,
                    borderRadius: 0,
                    px: 6,
                    py: '9px',
                    mr: '5px',
                    height: '48px',
                    minWidth: 'unset',
                    boxShadow: thickBoxShadow,
                    transitionDuration: '0s',
                    _active: {
                        boxShadow: 'none',
                        transform: translateXY5,
                    },
                },
                'clickable-secondary-active': {
                    bg: 'white',
                    borderColor: 'mineshaft',
                    borderWidth: 3,
                    borderRadius: 0,
                    px: 6,
                    py: '9px',
                    mr: '5px',
                    height: '48px',
                    minWidth: 'unset',
                    transitionDuration: '0s',
                    transform: translateXY5,
                },
                pressable: {
                    bg: 'rum',
                    borderColor: 'mineshaft',
                    borderWidth: 3,
                    borderRadius: 0,
                    color: 'white',
                    px: 6,
                    py: '9px',
                    height: '48px',
                    minWidth: 'unset',
                    _active: {
                        boxShadow: insetBoxShadow,
                        '& > *': {
                            transform: scale975,
                        },
                    },
                    _disabled: {
                        borderColor: 'alto2',
                        color: 'alto2',
                        bg: 'silver',
                        opacity: 1,
                    },
                },
                'pressable-small': {
                    bg: 'rum',
                    borderColor: 'mineshaft',
                    borderWidth: 3,
                    borderRadius: 0,
                    color: 'white',
                    px: 4,
                    py: '9px',
                    height: '35px',
                    minWidth: 'unset',
                    _active: {
                        boxShadow: insetBoxShadow,
                        '& > *': {
                            transform: scale975,
                        },
                    },
                    _disabled: {
                        borderColor: 'alto2',
                        color: 'alto2',
                        bg: 'silver',
                        opacity: 1,
                    },
                },
                'pressable-secondary': {
                    bg: 'white',
                    borderColor: 'mineshaft',
                    borderWidth: 3,
                    borderRadius: 0,
                    px: 6,
                    py: '9px',
                    height: '48px',
                    minWidth: 'unset',
                    _active: {
                        boxShadow: insetBoxShadow,
                        '& > *': {
                            transform: scale975,
                        },
                    },
                },
                'pressable-secondary-small': {
                    bg: 'white',
                    borderColor: 'mineshaft',
                    borderWidth: 3,
                    borderRadius: 0,
                    px: 4,
                    py: '9px',
                    height: '35px',
                    minWidth: 'unset',
                    _active: {
                        boxShadow: insetBoxShadow,
                        '& > *': {
                            transform: scale975,
                        },
                    },
                },
                disabled: {
                    bg: 'silver',
                    borderColor: 'alto2',
                    borderWidth: 3,
                    borderRadius: 0,
                    color: 'alto2',
                    px: 6,
                    py: '9px',
                    height: '48px',
                    minWidth: 'unset',
                    _hover: {
                        bg: 'silver',
                    },
                },
                pagination: {
                    bg: 'athensgray2',
                    borderColor: '#E3E3E3',
                    borderWidth: 3,
                    borderRadius: 0,
                    color: 'mineshaft',
                    px: 0,
                    py: 0,
                    height: '32px',
                    width: '32px',
                    minWidth: 'unset',
                    _hover: { borderColor: 'kimberly', bg: 'mischka' },
                    _active: { borderColor: 'kimberly', bg: 'mischka' },
                },
                'pagination-disabled': {
                    bg: 'athensgray2',
                    borderColor: '#E3E3E3',
                    borderWidth: 3,
                    borderRadius: 0,
                    color: 'alto2',
                    px: 0,
                    py: 0,
                    height: '32px',
                    width: '32px',
                    minWidth: 'unset',
                    cursor: 'not-allowed',
                },
                dark: {
                    bg: 'codgray',
                    color: '#FFF',
                    borderRadius: 0,
                    px: 6,
                    py: 8,
                    height: 'full',
                    _hover: { bg: 'codgray' },
                    textAlign: 'center',
                },
                simple: {
                    borderColor: 'rum',
                    borderWidth: 3,
                    borderRadius: 0,
                    px: 3,
                    py: 4,
                    minWidth: 'unset',
                    _active: {
                        boxShadow: insetBoxShadow,
                        '& > *': {
                            transform: scale975,
                        },
                    },
                    color: 'rum',
                },
            },
        },
        Divider: {
            sizes: {
                thick: {
                    borderBottomWidth: 3,
                    borderColor: 'alto',
                    opacity: 1,
                },
                thin: {
                    borderBottomWidth: 1,
                    borderColor: 'alto',
                    opacity: 1,
                },
            },
        },
        Switch: {
            variants: {
                retro: {
                    track: {
                        borderRadius: '0px',
                        width: '27px',
                        height: '9px',
                        border: defaultBorder,
                        backgroundColor: '#FAFAFA',
                        boxSizing: borderBox,
                        alignItems: 'center',
                    },
                    thumb: {
                        width: '15px',
                        height: '15px',
                        border: defaultBorder,
                        backgroundColor: '#AFD0DF',
                        marginLeft: '-6px',
                    },
                },
            },
        },
        Popover: {
            variants: {
                retro: {
                    body: {
                        py: 6,
                        px: 8,
                    },
                    content: {
                        borderRadius: 0,
                        borderWidth: 3,
                        borderColor: 'mineshaft',
                        boxShadow: thickBoxShadow,
                    },
                    arrow: {
                        boxShadow: noneImportant,
                        borderColor: 'mineshaft',
                        borderLeftWidth: 3,
                        borderBottomWidth: 3,
                        left: neg2Important,
                    },
                },
                'retro-top-arrow': {
                    body: {
                        py: 6,
                        px: 8,
                    },
                    content: {
                        borderRadius: 0,
                        borderWidth: 3,
                        borderColor: 'mineshaft',
                        boxShadow: thickBoxShadow,
                    },
                    arrow: {
                        boxShadow: noneImportant,
                        borderColor: 'mineshaft',
                        borderLeftWidth: 3,
                        borderTopWidth: 3,
                        top: neg2Important,
                    },
                },
                'retro-top-arrow-l3': {
                    body: {
                        py: 6,
                        px: 6,
                    },
                    content: {
                        _focusVisible: { boxShadow: arrowShadow },
                        borderRadius: 0,
                        borderWidth: 3,
                        borderColor: 'mineshaft',
                        boxShadow: arrowShadow,
                    },
                    arrow: {
                        boxShadow: noneImportant,
                        borderColor: 'mineshaft',
                        borderLeftWidth: 3,
                        borderTopWidth: 3,
                        top: neg2Important,
                    },
                },
                'retro-mobile': {
                    body: {
                        py: 4,
                        px: 4,
                    },
                    content: {
                        borderRadius: 0,
                        borderWidth: 3,
                        borderColor: 'mineshaft',
                        boxShadow: thickBoxShadow,
                        maxW: '270px',
                    },
                    arrow: {
                        boxShadow: noneImportant,
                        borderColor: 'mineshaft',
                        borderLeftWidth: 3,
                        borderBottomWidth: 3,
                        left: neg2Important,
                    },
                },
                'retro-mobile-top-arrow': {
                    body: {
                        py: 4,
                        px: 4,
                    },
                    content: {
                        borderRadius: 0,
                        borderWidth: 3,
                        borderColor: 'mineshaft',
                        boxShadow: thickBoxShadow,
                    },
                    arrow: {
                        boxShadow: noneImportant,
                        borderColor: 'mineshaft',
                        borderLeftWidth: 3,
                        borderTopWidth: 3,
                        top: neg2Important,
                        left: '2.5px !important',
                    },
                },
                'retro-right-arrow-l3': {
                    body: {
                        py: 6,
                        px: 6,
                    },
                    content: {
                        _focusVisible: { boxShadow: arrowShadow },
                        borderRadius: 0,
                        borderWidth: 3,
                        borderColor: 'mineshaft',
                        boxShadow: arrowShadow,
                    },
                    arrow: {
                        boxShadow: noneImportant,
                        borderColor: 'mineshaft',
                        borderRightWidth: 3,
                        borderTopWidth: 3,
                        marginLeft: '2px',
                        bgColor: 'red',
                        _before: {
                            content: `" "`,
                            position: 'absolute',
                            width: 'full',
                            height: 'full',
                            bgColor: 'mineshaft',
                            left: 2,
                            top: '-1px',
                        },
                        _after: {
                            content: `" "`,
                            position: 'absolute',
                            width: 'full',
                            height: 'full',
                            bgColor: 'white',
                        },
                    },
                },
                'confidence-helper': {
                    body: {
                        py: 5,
                        px: 5,
                        bg: '#F2F2F2',
                    },
                    content: {
                        borderRadius: 0,
                        borderWidth: 3,
                        borderColor: 'mineshaft',
                        boxShadow: arrowShadow,
                    },
                    arrow: {
                        bg: '#F2F2F2 !important',
                        boxShadow: arrowShadowImp,
                        borderColor: 'mineshaft',
                        borderRightWidth: 3,
                        borderBottomWidth: 3,
                    },
                },
                'top-arrow': {
                    body: {
                        py: 5,
                        px: 5,
                        bg: '#F2F2F2',
                    },
                    content: {
                        borderRadius: 0,
                        borderWidth: 3,
                        borderColor: 'mineshaft',
                        boxShadow: arrowShadow,
                    },
                    arrow: {
                        bg: '#F2F2F2 !important',
                        boxShadow: arrowShadowImp,
                        borderColor: 'mineshaft',
                        borderTopWidth: 3,
                        borderLeftWidth: 3,
                    },
                },
                'bottom-arrow': {
                    body: {
                        py: 5,
                        px: 5,
                        bg: '#F2F2F2',
                    },
                    content: {
                        borderRadius: 0,
                        borderWidth: 3,
                        borderColor: 'mineshaft',
                        boxShadow: arrowShadow,
                    },
                    arrow: {
                        bg: '#ffffff !important',
                        boxShadow: arrowShadowImp,
                        borderColor: 'mineshaft',
                        borderRightWidth: 3,
                        borderBottomWidth: 3,
                    },
                },
            },
            sizes: {
                '80vw': {
                    content: {
                        maxW: '80vw',
                    },
                },
                auto: {
                    content: {
                        maxW: 'auto',
                    },
                },
                270: {
                    content: {
                        maxW: '270px',
                    },
                },
                343: {
                    content: {
                        maxW: '343px',
                    },
                },
            },
        },
        Drawer: {
            variants: {
                'retro-mobile': {
                    parts: ['dialog', 'body'],
                    body: {
                        padding: 6,
                        border: defaultBorder,
                    },
                },
                contained: {
                    parts: ['dialog', 'body'],
                    dialog: { maxHeight: 'unset' },
                },
            },
            sizes: {
                1100: {
                    dialog: {
                        maxWidth: 1100,
                    },
                },
                800: {
                    dialog: {
                        maxWidth: 800,
                    },
                },
                270: {
                    dialog: {
                        maxWidth: 270,
                    },
                },
            },
        },
        Modal: {
            variants: {
                'retro-l2': {
                    parts: [
                        'header',
                        'overlay',
                        'dialogContainer',
                        'dialog',
                        'closeButton',
                        'body',
                        'footer',
                    ],
                    dialog: {
                        borderRadius: 0,
                        border: defaultBorder,
                        boxShadow: thickBoxShadow,
                    },
                },
            },
            sizes: {
                474: {
                    dialog: {
                        width: 474,
                    },
                },
                550: {
                    dialog: {
                        width: 550,
                    },
                },
                720: {
                    dialog: {
                        width: 720,
                    },
                },
                770: {
                    dialog: {
                        width: 770,
                    },
                },
                960: {
                    dialog: {
                        width: 960,
                    },
                },
            },
        },
        Progress: {
            variants: {
                retro: props => {
                    return {
                        parts: ['label', 'filledTrack', 'track'],
                        filledTrack: {
                            bgColor: '#0077fe',
                            borderRight:
                                props.value !== 0 && props.value !== props.max
                                    ? defaultBorder
                                    : 'none',
                        },
                        track: {
                            border: defaultBorder,
                            bgColor: 'white',
                            bg: 'url("/images/progress_bg_pattern.svg")',
                        },
                    }
                },
                retro2: {
                    parts: ['label', 'filledTrack', 'track'],
                    filledTrack: {
                        bgColor: '#4FAF54',
                    },
                    track: {
                        border: defaultBorder4,
                        bgColor: '#EDF7EE',
                    },
                },
                retro3: {
                    parts: ['label', 'filledTrack', 'track'],
                    filledTrack: {
                        bgColor: '#7C6A96',
                    },
                    track: {
                        bgColor: '#E2DEE8',
                    },
                },
            },
        },
        Textarea: {
            variants: {
                retro: {
                    borderRadius: 0,
                    border: defaultBorder,
                    _placeholder: { color: 'silver2', paddingTop: 1 },
                },
            },
        },
        Tooltip: {
            variants: {
                retro: {
                    backgroundColor: 'smoky',
                    borderRadius: 0,
                    border: defaultBorder,
                    py: '1px',
                    px: 3,
                    fontFamily: 'Rubik',
                    fontWeight: 'normal',
                    fontSize: 'sm',
                    color: 'white',
                },
                retro2: {
                    border: defaultBorder,
                    boxShadow: thickBoxShadow,
                    borderRadius: '0',
                },
            },
        },
        FormLabel: {
            variants: {
                retro: {
                    fontWeight: 'bold',
                    requiredIndicator: {
                        color: 'flushmahogany',
                    },
                    color: 'tundora',
                },
            },
        },
        FormError: {
            variants: {
                retro: {
                    text: {
                        color: 'flushmahogany',
                    },
                },
            },
        },
        Alert: {
            variants: {
                retro: props => {
                    let bg, borderColor, color
                    switch (props.status) {
                        case 'success':
                            bg = '#DCEFDD'
                            borderColor = '#4FAF54'
                            color = '#191919'
                            break
                        case 'error':
                            bg = '#F5D6D6'
                            borderColor = '#CB3434'
                            color = '#191919'
                            break
                        case 'warning':
                            bg = '#FCF1DA'
                            borderColor = '#F0B847'
                            color = '#191919'
                            break
                        case 'info':
                            bg = '#AFD0DF'
                            borderColor = '#3689B0'
                            color = '#191919'
                            break
                    }
                    return {
                        container: {
                            bg: bg,
                            border: `3px solid ${borderColor}`,
                            borderLeftWidth: 12,
                            color: color,
                        },
                        icon: {
                            color: borderColor,
                        },
                    }
                },
                'retro-mobile': props => {
                    let bg, borderColor, color
                    switch (props.status) {
                        case 'success':
                            bg = '#DCEFDD'
                            borderColor = '#4FAF54'
                            color = '#191919'
                            break
                        case 'error':
                            bg = '#F5D6D6'
                            borderColor = '#CB3434'
                            color = '#191919'
                            break
                        case 'warning':
                            bg = '#FCF1DA'
                            borderColor = '#F0B847'
                            color = '#191919'
                            break
                        case 'info':
                            bg = '#AFD0DF'
                            borderColor = '#3689B0'
                            color = '#191919'
                            break
                    }
                    return {
                        container: {
                            bg: bg,
                            border: `3px solid ${borderColor}`,
                            borderLeftWidth: 8,
                            color: color,
                        },
                        icon: {
                            color: borderColor,
                        },
                    }
                },
            },
        },
        PinInput: {
            variants: {
                retro: {
                    border: borderVariant5,
                    borderRadius: 'none',
                    _focus: {
                        boxShadow: 'none',
                        border: borderVariant6,
                    },
                    _invalid: {
                        border: borderVariant7,
                    },
                    width: '42px',
                    height: '52px',
                    fontWeight: 'bold',
                    marginInlineStart: zeroImportant,
                    marginRight: '24px !important',
                    fontFamily: 'Rubik',
                },
                retro2: {
                    border: borderVariant5,
                    borderRadius: 'none',
                    _focus: {
                        boxShadow: 'none',
                        border: borderVariant6,
                    },
                    _invalid: {
                        border: borderVariant7,
                    },
                    height: '64px',
                    fontWeight: 'bold',
                    marginInlineStart: zeroImportant,
                    marginRight: '24px !important',
                    fontFamily: 'Rubik',
                },
                'retro-mobile': {
                    border: borderVariant5,
                    borderRadius: 'none',
                    _focus: {
                        boxShadow: 'none',
                        border: borderVariant6,
                    },
                    _invalid: {
                        border: borderVariant7,
                    },
                    height: '48px',
                    fontWeight: 'bold',
                    marginInlineStart: zeroImportant,
                    marginRight: '12px !important',
                    fontFamily: 'Rubik',
                },
                'retro-mobile-2': {
                    border: borderVariant5,
                    borderRadius: 'none',
                    _focus: {
                        boxShadow: 'none',
                        border: borderVariant6,
                    },
                    _invalid: {
                        border: borderVariant7,
                    },
                    fontWeight: 'bold',
                    marginInlineStart: zeroImportant,
                    fontFamily: 'Rubik',
                },
                retro3: {
                    border: '3px solid #DEDEDE',
                    borderRadius: 'none',
                    w: '52px',
                    h: '12',
                    marginRight: '4',
                    boxSizing: borderBox,
                    fontWeight: '700',
                    fontFamily: 'Rubik',
                    fontSize: 'lg',
                    justifyContent: 'center',
                    _focus: {
                        boxShadow: 'none',
                        border: borderVariant6,
                    },
                    _invalid: {
                        border: borderVariant7,
                    },
                },
            },
            sizes: {
                '2xl': {
                    width: '64px',
                },
                xl: {
                    width: '52px',
                },
                lg: {
                    height: '48px',
                    width: '48px',
                },
                36: {
                    width: '36px',
                },
            },
        },
        Text: {
            variants: {
                body: {
                    fontFamily: 'Roboto',
                    fontWeight: 'normal',
                },
                'pseudo-heading': {
                    fontFamily: 'Rubik',
                    fontWeight: 'bold',
                },
            },
        },
        Input: {
            variants: {
                retro: {
                    parts: ['addon', 'field', 'element'],
                    field: {
                        border: defaultBorder,
                        borderRadius: 'none',
                        _focus: {
                            boxShadow: 'none',
                        },
                        _invalid: {},
                        _placeholder: { color: 'silver2' },
                    },
                },
            },
            sizes: {
                56: {
                    height: '56px',
                },
            },
        },
        NumberInput: {
            variants: {
                retro: {
                    parts: ['field'],
                    field: {
                        h: 'full',
                        borderRadius: 0,
                        border: defaultBorder,
                        _hover: {
                            border: defaultBorder,
                        },
                        _focusVisible: {
                            border: defaultBorder,
                            boxShadow: '0 0 0 2px #3182ce',
                        },
                        _disabled: {
                            borderColor: 'silver2',
                            opacity: 1,
                            color: 'silver2',
                        },
                        _invalid: {
                            border: defaultBorder,
                            boxShadow: 'none',
                        },
                        paddingLeft: {
                            base: 4,
                            md: 6,
                        },
                    },
                },
            },
            sizes: {
                56: {
                    height: '56px',
                },
            },
        },
        Radio: {
            variants: {
                retro: {
                    parts: ['control'],
                    control: {
                        borderColor: 'mineshaft',
                        _disabled: {
                            borderColor: 'silver2',
                        },
                        _checked: {
                            borderColor: '#0077FE',
                            backgroundColor: '#0077FE',
                            _hover: {
                                borderColor: '#0077FE',
                                backgroundColor: '#0077FE',
                            },
                        },
                    },
                },
                retro2: {
                    parts: ['control'],
                    control: {
                        borderColor: 'mineshaft',
                        _disabled: {
                            borderColor: 'silver2',
                        },
                        _checked: {
                            borderColor: 'rum',
                            backgroundColor: 'rum',
                            _hover: {
                                borderColor: 'rum2',
                                backgroundColor: 'rum2',
                            },
                        },
                    },
                },
            },
        },
        Checkbox: {
            variants: {
                retro: {
                    parts: ['control'],
                    control: {
                        borderColor: 'mineshaft',
                        borderRadius: 0,
                        _disabled: {
                            borderColor: 'silver2',
                        },
                        _checked: {
                            borderColor: '#0077FE',
                            backgroundColor: '#0077FE',
                            _hover: {
                                borderColor: '#0077FE',
                                backgroundColor: '#0077FE',
                            },
                        },
                    },
                },
            },
        },
    },
    styles: {
        global: {
            h1: headingStyle,
            h2: headingStyle,
            h3: headingStyle,
            h4: headingStyle,
            h5: headingStyle,
            h6: headingStyle,
            body: { color: 'codgray', lineHeight: '150% !important' },
        },
    },
})

export default theme
export {
    assessmentDivider,
    borderVariant6,
    borderVariant7,
    borderVariant8,
    borderVariant9,
    borderVariant10,
    borderVariant11,
    borderVariant12,
    borderVariant13,
    borderVariant14,
    borderVariant15,
    borderVariant16,
    borderVariant17,
    borderVariant18,
    borderVariant19,
    borderVariant20,
    borderVariant21,
    borderVariant22,
    borderVariant23,
    borderVariant24,
    borderVariant25,
    borderVariant26,
    borderVariant27,
    borderVariant28,
    borderVariant29,
    borderVariant30,
    borderVariant31,
    borderVariant32,
    borderVariant33,
    borderVariant34,
    borderVariant35,
    borderVariant36,
    borderVariant37,
    borderVariant38,
    borderVariant39,
    borderVariant40,
    borderVariant41,
    borderVariant42,
    borderVariantOnePixel,
    dashedBorder,
    dashedBorderAmethyst,
    dashedBorderDarkGray,
    dashedBorderRum,
    defaultBorder,
    defaultBorder2,
    defaultBorder3,
    defaultBorder5,
    flexStart,
    hiddenScrollbar,
    insetBoxShadow,
    scale975,
    spaceBetween,
    thickBoxShadow,
    thickBoxShadow2,
    thinBoxShadow,
    thinBoxShadow2,
    translateXY3,
    zeroImportant,
}
